import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRouteComp = (props) => {
  const location = useLocation();

  useEffect(() => {
    console.log("REAL MOUNT App");
    return () => console.log("REAL UNMOUNT App");
  }, []);

  if (sessionStorage.getItem("userInfo")) {
    return <>{props.children}</>;
  } else {
    return <Navigate to="/" />;
  }
};

export default PrivateRouteComp;
